export { default as ValueOfMoney } from './ValueOfMoney';